import * as digitalDataFormatters from "../src/digitalDataFormatters";

var _normalizePrice = function(item) {
    item = typeof item === 'object' ? item : {};

    var price = item.price && typeof(item.price) === 'object' ? item.price : item.price && typeof(item.price) === 'string' || typeof(item.price) === 'number' ? {
        "basePrice": item.price
    } : {};

    if (typeof price.priceType === 'undefined' && item.priceType) {
        price.priceType = item.priceType;
    }

    return price;
};


var skuOnly = function(itemArray) {
    var prodStr = ';',
        prodSku = "",
        item = {},
        prodInfo = {};

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];
            prodInfo = item.productInfo ? item.productInfo : item;
            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');
            prodStr = prodStr + prodSku + ';;;;';

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};


var productView = function(productArray) {


    var attachedLaborEventAndEvar = '',
        eVarArray = [],
        eventArray = [],
        prodStr = ';',
        prodSku = "",
        product = {},
        prodInfo = {};

    for (var index in productArray) {

        if (productArray.hasOwnProperty(index)) {

            product = productArray[index];

            attachedLaborEventAndEvar = '';

            eVarArray = [];

            eventArray = [];

            prodInfo = product.productInfo ? product.productInfo : product;

            prodSku = ( function ( pi ) {

                let sku = ( pi.sku ? pi.sku : '' );

                return ( sku && pi.laborType === "proreferral" ? `${sku}-pro` : sku );

            } ( prodInfo ) );

            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

            prodStr = prodStr + prodSku + ';;;';

            prodStr = prodStr + (Array.isArray(eventArray) ? eventArray.join("|") : '') + ';' + (Array.isArray(eVarArray) ? eVarArray.join("|") : '') + (prodInfo.proReferralDisplayed ? ",;" + prodSku + '-pro' + ";;;" + attachedLaborEventAndEvar : '');

        }
    }

        return (prodStr === ";" ? '' : prodStr);
};


var productImpression = function( itemArray ) {

    var prodStr = ';',
        prodSku = "",
        item = {},
        eVarArray = [],
        eventArray = [],
        prodInfo = {};

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];
            eVarArray = [];
            eventArray = [];

            prodInfo = item.productInfo ? item.productInfo : item;
            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

			eventArray.push('event124=' + digitalDataFormatters.stripComma(prodInfo.price ? prodInfo.price : ''));
			eVarArray.push('eVar116=' + (prodInfo.position ? prodInfo.position : ''));

            prodStr = prodStr + prodSku + ";;;" + (Array.isArray(eventArray) ? eventArray.join("|") : '') + ";" + (Array.isArray(eVarArray) ? eVarArray.join("|") : '');

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};


var cartAdd = function(itemArray) {

    var prodStr = ';',
        prodSku = "",
        item = {},
        eVarArray = [],
        eventArray = [],
        price = {},
        prodInfo = {},
        prodInfoOption = {};

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];
            eVarArray = [];
            eventArray = [];

            price = _normalizePrice(item);

            prodInfo = item.productInfo ? item.productInfo : item;
            prodInfoOption = prodInfo.option ? prodInfo.option : {};

            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

            // Set product string events
            eventArray.push('event2=' + digitalDataFormatters.stripComma(item.quantity));
            eventArray.push('event4=' + digitalDataFormatters.stripComma(price.basePrice));

            eventArray.push('event192=1'); // sku counter

			if (prodInfoOption.price) {
				eventArray.push('event157=' + digitalDataFormatters.stripComma(prodInfoOption.price));
			}

			if (prodInfoOption.color) {
				eVarArray.push('eVar23=' + prodInfoOption.color);
			}

			if (prodInfo.productType) {
				eVarArray.push('eVar50=' + prodInfo.productType);
			}

            prodStr = prodStr + prodSku + (prodInfo.proReferralSelected ? '-pro' : '') + ";;;" + (Array.isArray(eventArray) ? eventArray.join("|") : '') + ";";

            prodStr = prodStr + (Array.isArray(eVarArray) ? eVarArray.join("|") : '');

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};


var cartView = function(itemArray, ddo, options) {
    // handle optional arguments
    options = (typeof options !== "undefined" ? options : {});

    var prodStr = ';',
        prodSku = "",
        item = {},
        eVarArray = [],
        eventArray = [],
        price = {},
        prodInfo = {},
        prodInfoOption = {},
        stashATCLoc = (options.atcloc ? options.atcloc : "");

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];

            eVarArray = [];
            eventArray = [];
            price = _normalizePrice(item);
            prodInfo = item.productInfo ? item.productInfo : item;
            prodInfoOption = prodInfo.option ? prodInfo.option : {};
            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

            // stashATCLoc is only set during shared cart scenario
            if (stashATCLoc) {
                // Set product string events
                eventArray.push('event2=' + digitalDataFormatters.stripComma(item.quantity));
                eventArray.push('event4=' + digitalDataFormatters.stripComma(price.basePrice));
                eventArray.push('event192=1'); // sku counter
            }

			if (prodInfoOption.color) {
				eVarArray.push('eVar23=' + prodInfoOption.color);
			}

			if (prodInfo.productType) {
				eVarArray.push('eVar50=' + prodInfo.productType);
			}


            prodStr = prodStr + prodSku;

            prodStr = prodStr + ";;;" + (Array.isArray(eventArray) ? eventArray.join("|") : '') + ';' + (Array.isArray(eVarArray) ? eVarArray.join("|") : '');

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};


var cartCheckout = function(itemArray) {

    var item = {},
        prevProdStr = "",
        prodStr = ';',
        prodSku = "",
        prodInfo = {};

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];

            prevProdStr = prodStr;
            prodInfo = item.productInfo ? item.productInfo : item;
            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

            if (!prodInfo.proReferralDisplayed) {
                prodStr = prodStr + prodSku + (prodInfo.proReferralSelected ? '-pro' : '') + ';;;;';
            } else {
                prodStr = prevProdStr;
            }

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};


var cartRemove = function(itemArray, options) {

    // handle optional arguments
    options = (typeof options !== "undefined" ? options : {});

    var prodStr = ';',
        prodSku = "",
        item = {},
        eVarArray = [],
        eventArray = [],
        price = {},
        prodInfo = {},
        prodInfoOption = {},
        v95 = (options.v95 ? options.v95 : "");

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];
            eVarArray = [];
            eventArray = [];

            price = _normalizePrice(item);
            prodInfo = item.productInfo ? item.productInfo : item;
            prodInfoOption = prodInfo.option ? prodInfo.option : {};

            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

            // Set product string events
            eventArray.push('event17=' + digitalDataFormatters.stripComma(item.quantity));
            eventArray.push('event18=' + digitalDataFormatters.stripComma(price.basePrice));

			if (prodInfoOption.price) {
				eventArray.push('event175=' + digitalDataFormatters.stripComma(prodInfoOption.price));
			}

			if (prodInfoOption.color) {
				eVarArray.push('eVar23=' + prodInfoOption.color);
			}

			if (prodInfo.productType) {
				eVarArray.push('eVar50=' + prodInfo.productType);
			}

            if (v95) {
                eVarArray.push('eVar95=' + v95);
            }

            prodStr = prodStr + prodSku + ";;;" + (Array.isArray(eventArray) ? eventArray.join("|") : '') + ";";
            prodStr = prodStr + (Array.isArray(eVarArray) ? eVarArray.join("|") : '');

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};

var opc = function(itemArray) {

    var prodStr = ';',
        prodSku = "",
        item = {},
        eVarArray = [],
        prodInfo = {}

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];

            eVarArray = [];
            prodInfo = item.productInfo ? item.productInfo : item;
            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

            prodStr = prodStr + prodSku + ";;;;" + (Array.isArray(eVarArray) ? eVarArray.join("|") : '');

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};

var purchase = function(itemArray) {

    var prodStr = ';',
        prodSku = "",
        item = {},
        eVarArray = [],
        eventArray = [],
        price = {},
        prodInfo = {},
        prodInfoOption = {};

    for (var index in itemArray) {

        if (itemArray.hasOwnProperty(index)) {

            item = itemArray[index];
            eVarArray = [];
            eventArray = [];

            price = _normalizePrice(item);

            prodInfo = item.productInfo ? item.productInfo : item;
            prodInfoOption = prodInfo.option ? prodInfo.option : {};

            prodSku = prodInfo.sku ? prodInfo.sku : '';
            prodStr = prodStr + (prodStr.length > 5 ? ',;' : '');

			if (item.voucherCode) {
				eVarArray.push('eVar20=' + item.voucherCode);
				eventArray.push('event57=' + digitalDataFormatters.stripComma(item.voucherDiscount));
			}

			if (prodInfoOption.price) {
				eventArray.push('event178=' + digitalDataFormatters.stripComma(prodInfoOption.price));
			}

			if (prodInfoOption.color) {
				eVarArray.push('eVar23=' + prodInfoOption.color);
			}

			if (prodInfo.productType) {
				eVarArray.push('eVar50=' + prodInfo.productType);
			}

			prodStr = prodStr + prodSku + ';' + digitalDataFormatters.stripComma(item.quantity) + ';' + digitalDataFormatters.stripComma(price.basePrice) + ';' + (Array.isArray(eventArray) ? eventArray.join("|") : '') + ';';

            prodStr = prodStr + (Array.isArray(eVarArray) ? eVarArray.join("|") : '');

        }
    }

    return (prodStr === ";" ? '' : prodStr);
};

export {
    cartAdd,
    cartCheckout,
    cartRemove,
    cartView,
    opc,
    productImpression,
    productView,
    purchase,
    skuOnly
};